import $ from 'jquery';
import { SCROLL_ANIMATION_TIME, AUTOFOCUS_TIME } from '@/utils/constants';

const getFirstErrorInput = parent => parent.querySelector('.v-input.error--text');

export default ({
  parseSubmit,
} = {}) => ({
  props: {
    defaultValues: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },

  methods: {
    async onSubmit() {
      const success = await this.$refs.form.validate();

      if(success) {
        this.$emit('submit', parseSubmit ? parseSubmit(this.data) : { ...this.data });
      } else {
        this.goToFirstErrorInput();
      }
    },

    goToFirstErrorInput() {
      const inputNode = getFirstErrorInput(this.$el);

      if(!inputNode) return;

      const input = inputNode.querySelector('input');

      if(input) input.focus();
    },

    focusFirstInput() {
      const filterHiddenInputs = input => input.offsetParent !== null;
      const filterVSelectWithValue = node => node.classList.contains('v-select')
        ? !node.querySelector('input[type="hidden"]').value
        : true;

      const input = [...this.$el.querySelectorAll('.v-input:not(.v-input--is-dirty)')]
        .filter(filterHiddenInputs)
        .filter(filterVSelectWithValue)
        ?.[0];

      if(input.classList.contains('v-select')) $(input).find('.v-select__slot').click();
      else input.querySelector('input').focus()
    },
  },

  mounted() {
    setTimeout(() => {
      this.focusFirstInput();
    }, SCROLL_ANIMATION_TIME + (window.innerWidth < 768 ? AUTOFOCUS_TIME : 0));
  },
});

